import { useEffect, useMemo, useState } from "react";
import { createFileRoute, redirect, useLocation } from "@tanstack/react-router";
import { BuilderWorkspace } from "@/features/builder/BuilderWorkspace";
import { useAuth } from "@/hooks/useAuth";
import { createHttpBuilderApi } from "@/features/builder/api/httpBuilderApi";
import { getBuilderStart } from "@/features/builder/api/startApi";
import { useBuilderRouteNavigation } from "@/features/builder/hooks/useBuilderRouteNavigation";
import { CARD_SITE_HREF, chooseBuilder } from "@/features/builder/lib/cardSiteChoice";

// Each owner has one builder site; resolve its id without exposing it in the portal URL.
export const Route = createFileRoute("/builder")({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.session) {
      throw redirect({ to: "/auth/login", replace: true, search: { returnTo: location.href } });
    }
  },
  loader: async () => {
    const status = await getBuilderStart();
    if (!status?.siteId) throw redirect({ to: "/", replace: true });
    return { siteId: status.siteId, cardSite: status.cardSite };
  },
  component: BuilderRoute,
});

function BuilderRoute() {
  const { siteId, cardSite } = Route.useLoaderData();
  const location = useLocation();
  const { href } = location;
  const [dirty, setDirty] = useState(false);
  const navigation = useBuilderRouteNavigation(dirty);
  const { user } = useAuth();
  const api = useMemo(() => createHttpBuilderApi(), []);
  useEffect(() => { chooseBuilder(); }, []);
  return <BuilderWorkspace navigationController={navigation} onNavigationDirtyChange={setDirty} key={siteId} siteId={siteId} api={api} signInHref={`/auth/login?returnTo=${encodeURIComponent(href)}`} cardSiteHref={cardSite ? CARD_SITE_HREF : undefined} account={user?.email ? { email: user.email } : undefined} logoutHref="/auth/logout" />;
}
